// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const LoopOne = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M19.461 64.394a2.006 2.006 0 0 1-.835-.184L7.71 59.304a2 2 0 0 1 1.64-3.648l6.35 2.853a33.886 33.886 0 0 1 8.285-34.523 33.893 33.893 0 0 1 39.31-6.31 2 2 0 0 1-1.804 3.572 29.9 29.9 0 0 0-34.678 5.566 29.895 29.895 0 0 0-7.28 30.545l3.018-6.718a2 2 0 1 1 3.65 1.64L21.291 63.2a1.987 1.987 0 0 1-.587.76s0 .002-.003.002a2.003 2.003 0 0 1-1.198.431h-.043m28.552 17.584a33.917 33.917 0 0 1-15.307-3.654 2 2 0 1 1 1.801-3.571 29.904 29.904 0 0 0 34.68-5.565 29.896 29.896 0 0 0 7.28-30.545l-3.019 6.718a2 2 0 1 1-3.649-1.64l4.907-10.917c.175-.402.484-.748.901-.967l.056-.027a1.997 1.997 0 0 1 1.713-.018l10.914 4.906a2 2 0 0 1-1.64 3.648L80.3 37.49a33.887 33.887 0 0 1-8.286 34.524 33.901 33.901 0 0 1-24 9.962Zm-6.599-38.563a2 2 0 1 1-2.828-2.828l9.001-9c1.26-1.26 3.414-.368 3.414 1.414v30a2 2 0 1 1-4 0V37.828l-5.587 5.586Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default LoopOne;
